import type { EventAssignment, Registrant } from '../types';

type PublicAssignment = Pick<EventAssignment, 'leadershipRole' | 'taskRole' | 'taskSubDetail'>;

const buildPublicAssignments = (
  assignments?: Record<string, EventAssignment>
): Record<string, PublicAssignment> => {
  if (!assignments) return {};

  return Object.entries(assignments).reduce<Record<string, PublicAssignment>>(
    (publicAssignments, [eventId, assignment]) => {
      const publicAssignment: PublicAssignment = {
        leadershipRole: assignment.leadershipRole || '',
        taskRole: assignment.taskRole || '',
        taskSubDetail: assignment.taskSubDetail || ''
      };

      if (Object.values(publicAssignment).some(Boolean)) {
        publicAssignments[eventId] = publicAssignment;
      }

      return publicAssignments;
    },
    {}
  );
};

export const buildPublicRosterPayload = (
  id: string,
  registrant: Partial<Registrant>
): Record<string, unknown> => ({
  id,
  name: registrant.name || '',
  gender: registrant.gender || '',
  church: registrant.church || '',
  district: registrant.district || '',
  role: registrant.role || '',
  roles: registrant.roles || [],
  otherRoleDescription: registrant.otherRoleDescription || '',
  studentSpecialization: registrant.studentSpecialization || '',
  westernMedicineSpecialty: registrant.westernMedicineSpecialty || '',
  therapistSpecialty: registrant.therapistSpecialty || '',
  selectedEvents: registrant.selectedEvents || [],
  assignments: buildPublicAssignments(registrant.assignments),
  isApproved: true
});
